import { render, staticRenderFns } from "./ExamesGruposModal.vue?vue&type=template&id=2567ce5d&"
import script from "./ExamesGruposModal.vue?vue&type=script&lang=js&"
export * from "./ExamesGruposModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports